import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          background: '#18181B',
          color: '#F5F3ED',
          padding: 24,
          fontFamily: 'monospace',
        }}>
          <h2 style={{ color: '#C9A66B' }}>Terjadi Kesalahan</h2>
          <p style={{ color: '#B5B5BC', marginBottom: 16 }}>
            Ada error saat menampilkan halaman ini. Detail teknis di bawah — screenshot ini dan kirim ke admin:
          </p>
          <pre style={{
            background: '#1D1D20',
            border: '1px solid #48484E',
            borderRadius: 8,
            padding: 16,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            fontSize: 12,
            color: '#EF4444',
          }}>
            {String(this.state.error)}
            {'\n\n'}
            {this.state.info?.componentStack}
          </pre>
          <button
            onClick={() => window.location.href = '/login'}
            style={{
              marginTop: 20,
              background: '#C9A66B',
              color: '#18181B',
              border: 'none',
              padding: '10px 20px',
              borderRadius: 6,
              fontWeight: 'bold',
              cursor: 'pointer',
            }}
          >
            Kembali ke Login
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
